import React from "react";
import styled from "styled-components";
import Image from "react-bootstrap/Image";
import { Link } from "react-router-dom";

export const Footer = () => {
	return (
		<Wrapper className="flex-column flex-md-row mt-4">
			<Link className="m-auto" as={Link} to={"/"}>
				<Image
					className="footerImage"
					rounded
					fluid
					src={require("../images/logo.png")}
				/>
			</Link>
			<p className="text-light text-center">
				{`© ${new Date().getFullYear()} Ali A. All rights reserved.`}
			</p>
		</Wrapper>
	);
};

const Wrapper = styled.section`
	display: flex;
	padding: 1.5rem;
	background-color: #212529;
	.footerImage {
		width: 50px;
		margin: auto;
		box-shadow: 0px 0px 10px white;
	}
	p {
		font-weight: bold;
		font-size: 15px;
		margin: auto;
	}
`;
